import cn from 'classnames'
import { FC } from 'react'

import { Translation } from 'cng-common/features/translations'

import styles from './EspBadge.module.scss'

export type TEspBadgeVariant = 'neutral' | 'pending' | 'positive' | 'negative'

interface IEspBadgeProps {
  variant: TEspBadgeVariant
  /** Translation key for the label; use `label` instead for plain-data captions. */
  labelKey?: string
  label?: string
}

/** Dot + label status chip (mdfActivities StatusBadge pattern). */
export const EspBadge: FC<IEspBadgeProps> = ({ variant, labelKey, label }) => (
  <span className={cn(styles.badge, styles[variant])}>
    <span className={styles.dot} />
    {labelKey ? <Translation text={labelKey} span /> : <span>{label}</span>}
  </span>
)

EspBadge.displayName = 'EspBadge'
